export const generateHashId = (...args: (string | string[])[]): string => {
	// Combine the arguments into a single string
	let inputString = '';
	if (args?.length > 0) {
		args.forEach((arg) => {
			if (typeof arg === 'string') {
				inputString += arg;
			} else if (Array.isArray(arg)) {
				inputString += arg.join('');
			}
		});
	}

	// CRC32 implementation
	let crc = 0xffffffff;
	for (let i = 0; i < inputString.length; i++) {
		let charCode = inputString.charCodeAt(i);
		for (let j = 0; j < 8; j++) {
			if ((crc ^ charCode) & 1) {
				crc = (crc >>> 1) ^ 0xedb88320;
			} else {
				crc = crc >>> 1;
			}
			charCode >>>= 1;
		}
	}

	// XOR with 0xFFFFFFFF and convert to a hexadecimal string
	crc = (crc ^ 0xffffffff) >>> 0;
	const hashHex = crc.toString(16);

	return hashHex;
};

// Example usage:
// const args1 = ['arg1', 'arg2', 'arg3'];
// const id1 = generateStringHashId(args1);

// const args2 = ['arg3', 'arg2', 'arg1']; // Reordered args
// const id2 = generateStringHashId(args2);

// console.log(id1);
// console.log(id2);
// console.log(id1 === id2); // Should be true
